export const API_KEY = "455c026cdba1d4666c6d0bed168a1040";
export const TMDB_BASE_URL = "https://api.themoviedb.org/3";
